import { render, staticRenderFns } from "./IotSensorReadRecordsModal.vue?vue&type=template&id=bc76b06a&"
import script from "./IotSensorReadRecordsModal.vue?vue&type=script&lang=js&"
export * from "./IotSensorReadRecordsModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports